import { render, staticRenderFns } from "./risk_line.vue?vue&type=template&id=d53b9028&scoped=true"
import script from "./risk_line.vue?vue&type=script&lang=js"
export * from "./risk_line.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d53b9028",
  null
  
)

export default component.exports